import "./reviews.scss";
import { useTranslation } from "react-i18next";

const reviews = [
  { name: "მარიამ გ.", stars: 5, text: "review_1" },
  { name: "გიორგი თ.", stars: 5, text: "review_2" },
  { name: "ნინო მ.", stars: 5, text: "review_3" },
  { name: "დავით კ.", stars: 5, text: "review_4" },
];

const Stars = ({ count }) => (
  <div className="stars">
    {[...Array(count)].map((_, i) => (
      <span key={i}>★</span>
    ))}
  </div>
);

const Reviews = () => {
  const { t } = useTranslation();
  return (
    <section className="reviews-section">
      <div className="reviews-header">
        <h2>{t("reviews_title")}</h2>
        <p>{t("reviews_subtitle")}</p>
      </div>
      <div className="reviews-grid">
        {reviews.map((r, i) => (
          <div key={i} className="review-card">
            <Stars count={r.stars} />
            <p className="review-text">"{t(r.text)}"</p>
            <div className="review-author">
              <div className="review-avatar">{r.name.charAt(0)}</div>
              <span>{r.name}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Reviews;
